module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.54e5ab3.woff2";